import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '@/App';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useContext(AuthContext);
  // Use useRef instead of useState for the processed flag (prevents StrictMode race conditions)
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Check for session_id in URL hash/fragment (Emergent Auth format)
        const hash = location.hash || window.location.hash;
        let sessionId = null;
        
        if (hash && hash.includes('session_id=')) {
          const params = new URLSearchParams(hash.substring(1));
          sessionId = params.get('session_id');
        }

        if (sessionId) {
          // Get pending user_type from localStorage
          const userType = localStorage.getItem('pending_user_type') || 'professional';
          localStorage.removeItem('pending_user_type');
          
          // Call backend to process session
          const response = await axios.post(`${API}/auth/session`, {
            session_id: sessionId,
            user_type: userType
          }, {
            withCredentials: true
          });
          
          const { token, user } = response.data;
          
          // Login with JWT token for backward compatibility
          login(token, user);
          
          // Clean the URL hash
          window.history.replaceState(null, '', window.location.pathname);
          
          toast.success('Accesso con Google effettuato con successo!');
          navigate('/dashboard', { replace: true, state: { user } });
          return;
        }

        // Check for legacy query params (backward compatibility)
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');
        const userParam = searchParams.get('user');
        const error = searchParams.get('error');

        if (error) {
          toast.error('Errore durante l\'autenticazione con Google');
          navigate('/auth', { replace: true });
          return;
        }

        if (token && userParam) {
          try {
            const user = JSON.parse(userParam);
            login(token, user);
            toast.success('Accesso con Google effettuato con successo!');
            navigate('/dashboard', { replace: true });
          } catch (e) {
            console.error('Error parsing user data:', e);
            toast.error('Errore durante l\'autenticazione');
            navigate('/auth', { replace: true });
          }
          return;
        }

        // No valid auth data found
        navigate('/auth', { replace: true });
        
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Errore durante l\'autenticazione');
        navigate('/auth', { replace: true });
      }
    };

    processAuth();
  }, [location, login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 mx-auto mb-4"></div>
        <p className="text-slate-600">Completamento accesso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
